// extracted by mini-css-extract-plugin
module.exports = {"org_container":"org_container--Organization-routes__2n8jw","orgContainer":"org_container--Organization-routes__2n8jw","table":"table--Organization-routes__2uIrw"};